import { removeFocus, addFocus } from '../helpers/focus-elements';

(() => {
  const header = document.querySelector('.g01');

  if (header === null) {
    return;
  }

  // Scroll to the top of the page if already on homepage.
  const logoLink = header.querySelector('.g01__logo');
  if (document.body.classList.contains('home')) {
    logoLink.addEventListener('click', e => {
      e.preventDefault();
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    });
  }

  const menuWrapper = header.querySelector('.g01__menu-wrapper');
  const menuElements = menuWrapper.querySelectorAll('input, a, button');

  if (window.outerWidth < 1240) {
    removeFocus(menuElements);
  }

  let isActive = false;
  const hamburger = header.querySelector('.g01__hamburger');
  if (hamburger !== null) {
    hamburger.addEventListener('click', () => {
      isActive = ! isActive;
      document.body.classList.toggle('is-menu-active');

      if (window.outerWidth < 1240) {
        if (isActive) {
          addFocus(menuElements);
        } else {
          removeFocus(menuElements);
        }
      }
    });
  }

  const scrollDetection = document.querySelector('.g01__scroll-detection');

  if (scrollDetection === null) {
    return;
  }
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        header.classList.remove('is-scrolled');
      } else {
        header.classList.add('is-scrolled');
      }
    });
  }, {
    threshold: 1.0,
    rootMargin: '0px 0px -200px 0px'
  });
  observer.observe(scrollDetection);
})();